import React, { useRef } from "react";

import { Grid } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import FieldView from "../../../../../../../../../components/Form/FieldView";
import { Branch } from "../../../../../../../../../models/branch";
import { Job } from "../../../../../../../../../models/job";
import { ItemJob } from "../../../../../../../../../models/sales";
import { StorageBox } from "../../../../../../../../../models/storage.box";
import { Warehouse } from "../../../../../../../../../models/warehouse";
import { groupStorageBoxOrders } from "../../../../../../../../../util/groupStorageBoxOrders";
import {
  OrderView,
  OrderViewComponentHandler,
} from "../../../../../../../Moving/Warehousing/Transshipments/components/OrderViewComponent";
import {
  Details,
  EmptyValue,
  OrderLink,
  OrderReference,
  OrderRoot,
  OrderUploadDate,
  OrderWrapper,
  OrdersLabel,
} from "./styles";

interface Props {
  value?: StorageBox;
}

export const DetailsTab = ({ value }: Props) => {
  const { t: translate } = useTranslation();

  const orderViewComponentRef = useRef<OrderViewComponentHandler>(null);

  const getNames = (value?: Branch[] | Warehouse[]) => {
    if (!value?.length) return;

    const names = value?.map((value) => value?.name);

    if (names?.length) {
      return names.join(", ");
    }

    return "";
  };

  let jobs =
    value?.itemsJobs?.reduce((jobs: Job[], itemJob: ItemJob) => {
      if (itemJob.job) jobs.push(itemJob.job);

      return jobs;
    }, []) || [];

  if (value?.jobs) {
    jobs = [...jobs, ...value.jobs];
  }

  const orders = groupStorageBoxOrders(jobs);

  return (
    <Details>
      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <FieldView label={translate("number")} value={value?.number} />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <FieldView label={translate("type")} value={value?.storageBoxType?.name || ""} />
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <FieldView label={translate("branches")} value={getNames(value?.branches)} />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <FieldView label={translate("warehouses")} value={getNames(value?.warehouses)} />
        </Grid>
      </Grid>
      <Grid item container direction="column" xs={12}>
        <OrdersLabel>{translate("orders")}</OrdersLabel>
        <OrderWrapper>
          {!orders.length && <EmptyValue>{translate("empty")}</EmptyValue>}
          {orders.map((job) => (
            <OrderRoot key={`item-job-${job.id}`}>
              <div>
                <OrderReference>
                  <OrderLink
                    onClick={() => {
                      orderViewComponentRef?.current?.open(Number(job.id));
                    }}
                  >
                    {job?.reference}
                  </OrderLink>{" "}
                  - {job?.customer?.fullName}
                </OrderReference>
              </div>
              <div>
                <OrderUploadDate>
                  <b>{translate("uploadDate")}: </b>
                  <span>
                    {job?.updatedAt ? format(new Date(job?.updatedAt), "dd/MM/yyyy") : ""}
                  </span>
                </OrderUploadDate>
              </div>
            </OrderRoot>
          ))}
        </OrderWrapper>
      </Grid>
      <OrderView ref={orderViewComponentRef} />
    </Details>
  );
};
